import YAML from 'yamljs';

import { toast } from '@features/toast.feature';

export const downloadYamlConfig = (data: object, filename: string) => {
  try {
    const yamlStr = YAML.stringify(data, 4);
    const blob = new Blob([yamlStr], { type: 'text/yaml' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.yaml`;
    a.click();

    URL.revokeObjectURL(url);
  } catch (error) {
    toast.error(`Failed to download input params: ${error}`);
  }
};
